import React from 'react';
import {
  Container,
  Typography,
  Grid,
  List,
  ListItem,
  Box,
} from '@mui/material';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import pro360Logo from '../../assets/images/pro360-logo.png';

const AboutPage = () => {
  return (
    <LayoutContainer>
      <AdminHeader title='ABOUT' />
      <div className='page-content-wrapper scrollable'>
        <Container sx={{ padding: '20px', maxWidth: '1200px' }}>
          <section style={{ marginBottom: '30px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography
                variant='h4'
                sx={{ color: '#015eb6', marginBottom: '5px', fontWeight: 550 }}
              >
                About
              </Typography>
              <img src={pro360Logo} style={{ marginRight: '4rem' }} />
            </Box>
            <Typography
              variant='body1'
              sx={{ fontSize: '0.875rem', lineHeight: '1.6', mt: 4 }}
            >
              This app is a custom solution built by VERIFY360 for PROCAM to
              optimize event operations. It provides tools for efficient
              inventory management and real-time ambulance tracking on the
              marathon route and junctions.
              {/* Verify360 is one of the world’s fastest growing background
              verification experts. It is continually ranked among the top
              background screening & risk mitigation firms. We serve our clients
              in more than 21 countries. Today, Verify360 is a popular
              consulting firm with major centres in London, Dubai, Saudi Arabia,
              India and Singapore. */}
            </Typography>
          </section>
          <section style={{ marginBottom: '30px' }}>
            <Typography
              variant='h5'
              sx={{ color: '#000', marginBottom: '10px', fontWeight: 600,fontSize:'1.2rem' }}
            >
              What it does
            </Typography>
            <Typography
              variant='body1'
              sx={{ fontSize: '0.875rem', lineHeight: '1.6' }}
            >
              <div style={{ paddingLeft: '1.5rem' }}>
                <li>
                  <b>Inventory</b>: Track and manage race event resources
                  (water, energy products, etc.) at relevant aid stations with
                  real-time updates.
                </li>
                <li>
                  <b>Ambulances</b>: Monitor ambulance locations and movements
                  during race events with live GPS tracking and route history.
                </li>
              </div>
              {/* Verify360 is one of the world’s fastest growing background
              verification experts. It is continually ranked among the top
              background screening & risk mitigation firms. We serve our clients
              in more than 21 countries. Today, Verify360 is a popular
              consulting firm with major centres in London, Dubai, Saudi Arabia,
              India and Singapore. */}
            </Typography>
          </section>
          <section style={{ marginBottom: '30px' }}>
            <Typography
              variant='h5'
              sx={{ color: '#000', marginBottom: '10px', fontWeight: 600,fontSize:'1.2rem' }}
            >
              Why it matters
            </Typography>
            <Typography
              variant='body1'
              sx={{ fontSize: '0.875rem', lineHeight: '1.6' }}
            >
              <div style={{ paddingLeft: '1.5rem' }}>
                <li>
                  <b>Streamlined Operations</b>: Improved coordination and
                  communication between teams.
                </li>
                <li>
                  <b>Data-Driven Decisions</b>: Centralized information for
                  better resource allocation and planning.
                </li>
                <li>
                  <b>Ease of Use</b>: Intuitive interface accessible on both
                  mobile and desktop devices.
                </li>
              </div>
              {/* Verify360 is one of the world’s fastest growing background
              verification experts. It is continually ranked among the top
              background screening & risk mitigation firms. We serve our clients
              in more than 21 countries. Today, Verify360 is a popular
              consulting firm with major centres in London, Dubai, Saudi Arabia,
              India and Singapore. */}
            </Typography>
          </section>
          <i>
            <b>Version 2.3</b>
          </i>
          <div style={{ marginTop: 10 }}>
            <b>Contact for Support:</b>{' '}
            <a href='mailto:support@verify360.com'>support@verify360.com</a>
          </div>
          {/* <section style={{ marginBottom: '30px' }}>
            <Typography
              variant='h5'
              sx={{ color: '#1C90FF', marginBottom: '5px', fontWeight: 550 }}
            >
              Application Overview
            </Typography>
            <Typography
              variant='body1'
              sx={{ fontSize: '0.875rem', lineHeight: '1.6', color: '#34495e' }}
            >

            </Typography>
          </section> */}
          {/* Mission Statement Section */}
          {/* <section style={{ marginBottom: '30px' }}>
            <Typography
              variant='h5'
              sx={{ color: '#1C90FF', marginBottom: '5px', fontWeight: 550 }}
            >
              Our Mission
            </Typography>
            <Typography
              variant='body1'
              sx={{ fontSize: '0.875rem', lineHeight: '1.6', color: '#34495e' }}
            >
              At Verify360, our mission is to provide exceptional background
              verification services that empower organizations to make informed
              decisions. We leverage cutting-edge technology and a dedicated
              global team to deliver accurate and timely results.
            </Typography>
          </section> */}
          {/* Locations Section */}
          {/* <section style={{ marginBottom: '30px' }}>
            <Typography
              variant='h5'
              sx={{ color: '#1C90FF', marginBottom: '5px', fontWeight: 550 }}
            >
              Our Global Presence
            </Typography>
            <Typography
              variant='body1'
              sx={{ fontSize: '0.875rem', lineHeight: '1.6', color: '#34495e' }}
            >
              We operate with major centers located in key business hubs across
              the world, including:
            </Typography>
            <List sx={{ marginLeft: '20px', marginTop: '10px' }}>
              <ListItem
                sx={{ fontSize: '0.875rem', color: '#34495e', fontWeight: 550 }}
              >
                1. London, United Kingdom
              </ListItem>
              <ListItem
                sx={{ fontSize: '0.875rem', color: '#34495e', fontWeight: 550 }}
              >
                2. Dubai, United Arab Emirates
              </ListItem>
              <ListItem
                sx={{ fontSize: '0.875rem', color: '#34495e', fontWeight: 550 }}
              >
                3. Saudi Arabia
              </ListItem>
              <ListItem
                sx={{ fontSize: '0.875rem', color: '#34495e', fontWeight: 550 }}
              >
                4. India
              </ListItem>
              <ListItem sx={{ fontSize: '0.875rem', color: '#34495e', fontWeight:550 }}>
                5. Singapore
              </ListItem>
            </List>
            <Typography
              variant='body1'
              sx={{ fontSize: '0.875rem', color: '#34495e' }}
            >
              We proudly serve clients across 21 countries and continue to
              expand our reach to help organizations worldwide.
            </Typography>
          </section> */}
        </Container>
      </div>
    </LayoutContainer>
  );
};

export default AboutPage;
